export default {
  allMsg: 'Tutti i messaggi',
  systemMsg: 'Messaggi di sistema',
  personMsg: 'Messaggi manuali',
  unread: 'Non letto',
  seeDetail: 'Vedi dettagli',
  read: 'Letto',
  replyNow: 'Rispondi ora',
  message: 'Messaggio',
  operateSuccess: 'Operazione riuscita',
  holder: {
    searchHolder: 'N. pacco/N. ordine/N. articolo',
  },
  addAcBuy: 'Unisciti ad AcBuy Discord e vinci 2000 ¥ in CASH!',
  joinNow: 'Unisciti qui',
  flatActivity: 'Saldi Black Friday di Acbuy',
  joinNow1: 'Unisciti ora',
  tips1: 'Approfitta di sconti fino al 70%',
  tips2: 'Inserisci il codice per ottenere subito il tuo coupon di spedizione da ¥110!',
}
